/*
 * @Descripttion: 
 * @Author: wangws
 * @Date: 2024-07-27 16:17:04
 * @LastEditors: wangws
 * @LastEditTime: 2024-07-27 16:17:10
 * @FilePath: util.js
 */
import Vue from 'vue'  
export default new Vue   